import pxToRem from "../functions/pxToRem";

export default function linearProgress({ borders, colors }) {
  const { borderRadius } = borders;
  const { light } = colors;

  const linearProgress = {
    styleOverrides: {
      root: {
        height: pxToRem(6),
        borderRadius: borderRadius.md,
        overflow: "visible",
        position: "relative",
      },

      colorPrimary: {
        backgroundColor: light.main,
      },

      colorSecondary: {
        backgroundColor: light.main,
      },

      bar: {
        height: pxToRem(6),
        borderRadius: borderRadius.sm,
        position: "absolute",
        transform: `translate(0, 0) !important`,
        transition: "width 0.6s ease !important",
      },
    },
  };

  return linearProgress;
}
